import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetExpenseData, apiPutExpense, apiDeleteExpense } from 'services/ExpenseService'

export const getExpenses = createAsyncThunk('expenseList/data/getExpenses',async (data) => {
    const response = await apiGetExpenseData(data)
    return response.data
})

export const updateExpense = async (data) => {
    const response = await apiPutExpense(data)
    return response.data
}

export const deleteExpense = async (data) => {
    const response = await apiDeleteExpense(data)
    return response.data
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    sort: {
        order: '',
        key: ''
    }
}

export const initialFilterData = {
    name: '',
    category: ['bags', 'cloths', 'devices', 'shoes', 'watches'],
    status: [0, 1, 2],
    expenseStatus: 0,
}

export const initialState = {
    loading: false,
    expenseList: [],
    openFeedback: '',
    tableData: initialTableData,
    filterData: initialFilterData,
}

const dataSlice = createSlice({
    name: 'expenseList/data',
    initialState,
    reducers: {
        reset: () => initialState,
        updateExpenseList: (state, action) => {
            state.expenseList = action.payload
        },
        setTableData: (state, action) => {
            state.tableData = action.payload
        },
        setFilterData: (state, action) => {
            state.filterData = action.payload
        },
    },
    extraReducers: (builder) => {
		builder.addCase(getExpenses.fulfilled, (state, action) => {
            state.expenseList = action.payload.items
            state.tableData.total = action.payload?.meta?.totalItems
            state.openFeedback = action.payload?.open_feedback
            state.loading = false
        })
        builder.addCase(getExpenses.pending, (state) => {
            state.loading = true
        })
    }
})

export const { reset, updateExpenseList, setTableData, setFilterData, setSortedColumn } = dataSlice.actions

export default dataSlice.reducer
